/* eslint-disable react/prop-types */
import { useEffect, useState } from "react";
import Navbar from "./navbar";
import Sidebar from "./sidebar";
import useWindowResize from "../../lib/utils";
import { Toaster } from "../ui/toaster";

const Layout = ({ children }) => {
  // const [isSidebarCompress, setIsSidebarCompress] = useState(false);
  // const { width } = useWindowResize();
  const [isSidebarCompress, setIsSidebarCompress] = useState(null);
  const { width } = useWindowResize();
  window?.innerWidth >= 1280 &&
    isSidebarCompress === null &&
    setIsSidebarCompress(true);

  const toggleSidebar = () => {
    setIsSidebarCompress(!isSidebarCompress);
  };
  useEffect(() => {
    // window.addEventListener("resize",()=>setIsSidebarCompress(window.innerWidth>768))
    if (width <= 1280) {
      setIsSidebarCompress(false);
    } else {
      setIsSidebarCompress(true);
    }
  }, [width]);
  console.log(isSidebarCompress, "@TEST...");
  return (
    <>
      <div className="flex relative w-full">
        <div className="max-w-[240px]">
          <Sidebar
            toggleSidebar={toggleSidebar}
            isSidebarCompress={isSidebarCompress}
          />
        </div>
        <div
          onClick={toggleSidebar}
          className={`bg-white/5 ${
            !isSidebarCompress
              ? "hidden"
              : "md:hidden z-[45] block fixed left-0 top-0  h-full w-full"
          }`}
        ></div>
        {/* <div className={`bg-slate-100 px-[1px]`}></div> */}
        <div className="w-[calc(100%-240px)] flex flex-col flex-1 max-h-max px-5 md:px-10 dark:bg-dark1 bg-white">
          <Navbar toggleSidebar={toggleSidebar} />
          <div className=" sm:px-5 min-h-[calc(100vh-96px)] py-8 mb-10">
            {children}
          </div>
        </div>
      </div>
      <Toaster />
    </>
  );
};

export default Layout;
